<div class="flex flex-row place-content-center items-start">
  <div class="flex flex-col w-full max-w-screen-2xl">
    <div class="flex flex-row place-content-center items-center py-8 px-2 w-full">
      <div class="bg-white rounded-2xl px-4 border border-grey-600 flex flex-row place-content-between items-center">
        <mat-icon class="text-blue-700 mr-2">filter_list</mat-icon>
        <form [formGroup]="filterForm">
          <mat-form-field class="mt-0.5 w-80" *ngIf="filteredMessageTypes$ | async as messageTypes">
            <mat-select class="text-black" formControlName="messageType" name="messageType">
              <mat-option [routerLink]="''" merge [queryParams]="{messageType: null}" [value]="999">All</mat-option>
              <mat-option [routerLink]="''" merge [queryParams]="{messageType: messageType.id}"
                *ngFor="let messageType of messageTypes | orderBy: ['description']" [value]="messageType.id">
                {{messageType.description}}</mat-option>
            </mat-select>
          </mat-form-field>
        </form>
      </div>
    </div>
    <ng-container *ngIf="!loading && templateFacade.selectedLanguage$ | async as selectedLanguage">
      <ng-container *ngIf="filterForm.get('messageType').value === 999;else breakdown">

        <div class="flex flex-row flex-wrap" [@simpleFadeAnimation]="filteredTemplates.length">
          <ng-container *ngFor="let template of filteredTemplates | orderBy: ['name']">
            <div *ngIf="template.languageDefinitionMap[selectedLanguage]"
              class="w-1/2 lg:w-1/3 flex flex-row place-content-center items-center">
              <a [routerLink]="'/editor/' + template.id" [queryParams]="{language: selectedLanguage}">
                <div class="flex flex-col rounded-lg overflow-hidden w-full max-w-xs bg-white mb-8 shadow-2xl grow">
                  <img class="h-auto w-full" [src]="template.languageDefinitionMap[selectedLanguage].previewImageUrl">
                  <mat-divider></mat-divider>
                  <div class="flex flex-col p-4">
                    <div class="flex flex-row place-content-between items-center mb-1.5">
                      <h3 class="flex-grow font-bold m-0 text-black"
                        style="text-decoration:underline; text-decoration-style: double;text-decoration-color: rgb(1,90,156);">
                        {{template.languageDefinitionMap[selectedLanguage].name}}</h3>
                    </div>
                    <span class="text-grey-600">{{template.languageDefinitionMap[selectedLanguage].description}}</span>
                  </div>
                </div>
              </a>
            </div>
          </ng-container>
        </div>

      </ng-container>
      <ng-template #breakdown>
        <div class="flex flex-col"
          *ngFor="let filteredTemplate of filteredTemplates | keyvalue | orderBy: ['value.messageTypeDescription'];let index = i;trackBy: trackMessageTypeRepeater">
          <ng-container *ngIf="filteredTemplate.value.templates.length > 0">
            <div class="flex flex-row flex-wrap" [@simpleFadeAnimation]="filteredTemplate.value.templates.length">
              <ng-container *ngFor="let template of filteredTemplate.value.templates | orderBy: ['name']">
                <div *ngIf="template.languageDefinitionMap[selectedLanguage]" fxFlex="50" fxFlex.gt-md="33.33"
                  class="flex flex-row place-content-center items-center">
                  <a [routerLink]="'/editor/' + template.id" [queryParams]="{language: selectedLanguage}">
                    <div class="flex flex-col rounded-lg overflow-hidden w-full max-w-xs bg-white mb-8 shadow-2xl grow">
                      <img class="h-auto w-full"
                        [src]="template.languageDefinitionMap[selectedLanguage].previewImageUrl">
                      <mat-divider></mat-divider>
                      <div class="flex flex-col p-4">
                        <div class="flex flex-row place-content-between items-center mb-1.5">
                          <h3 class="flex-grow font-bold m-0 text-black"
                            style="text-decoration:underline; text-decoration-style: double;text-decoration-color: rgb(1,90,156);">
                            {{template.languageDefinitionMap[selectedLanguage].name}}</h3>
                          <button mat-icon-button *ngIf="filteredTemplate.value.defaultTemplateRequired"
                            (click)="$event.preventDefault();$event.stopPropagation();setDefault(template.messageTypeId, template);">

                            <mat-icon *ngIf="filteredTemplate.value.defaultTemplateId === template.id;else outline"
                              color="accent">star</mat-icon>
                            <ng-template #outline>
                              <mat-icon color="accent">star_outline</mat-icon>
                            </ng-template>
                          </button>
                        </div>
                        <span class="text-grey-600">{{template.description}}</span>
                      </div>
                    </div>
                  </a>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </ng-template>
    </ng-container>
  </div>
</div>